import { render } from "./MinhaDashboard.vue?vue&type=template&id=57dea0cd&scoped=true&ts=true"
import script from "./MinhaDashboard.vue?vue&type=script&lang=ts"
export * from "./MinhaDashboard.vue?vue&type=script&lang=ts"

import "./MinhaDashboard.vue?vue&type=style&index=0&id=57dea0cd&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dea0cd"]])

export default __exports__